import ErrorIcon from "@mui/icons-material/Error";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Header from "./header.tsx";

function NotVerifiedDocument(): React.JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigateBack = (): void => {
    navigate("/");
  };

  return (
    <>
      <Header />
      <Stack
        alignItems="center"
        sx={{
          paddingY: 4,
        }}
      >
        <Stack spacing={4} sx={{ width: "100%", maxWidth: "md" }}>
          <div>
            <Container maxWidth="md">
              <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
                spacing={2}
              >
                <Typography variant="h5">{t("notVerified.title")}</Typography>
                <ErrorIcon color="error" />
              </Stack>
            </Container>
          </div>
          <Box sx={{ backgroundColor: "#fafafa" }}>
            <Container sx={{ paddingY: 3 }}>
              <Typography gutterBottom variant="h6">
                {t("notVerified.description")}
              </Typography>
              <Typography color="text.secondary" variant="body1">
                {t("notVerified.hint")}
              </Typography>
            </Container>
          </Box>
          <div>
            <Container>
              <Button
                fullWidth
                onClick={handleNavigateBack}
                size="large"
                variant="contained"
              >
                {t("notVerified.restart")}
              </Button>
            </Container>
          </div>
        </Stack>
      </Stack>
    </>
  );
}

export default NotVerifiedDocument;
